import { useState } from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleNewsletter = (e) => {
    e.preventDefault();
    if (email) {
      setSubscribed(true);
      setEmail('');
      setTimeout(() => setSubscribed(false), 3000);
    }
  };

  return (
    <footer className="relative bg-charcoal text-cream-200">
      {/* Newsletter Section */}
      <div className="bg-gradient-to-r from-charcoal-dark via-charcoal to-charcoal-dark">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-8">
            <div>
              <h3 className="text-2xl font-serif font-semibold text-white mb-2">Stay Updated</h3>
              <p className="text-cream-200/60 font-sans text-sm">Get the latest updates on new projects and exclusive offers.</p>
            </div>
            <form onSubmit={handleNewsletter} className="flex w-full lg:w-auto gap-3">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                required
                className="w-full lg:w-72 bg-white/5 border border-gold/20 px-5 py-3 font-sans text-sm text-white placeholder-cream-200/30 focus:border-gold focus:outline-none transition-colors"
              />
              <button type="submit" className="btn-premium-filled shrink-0">
                <span>{subscribed ? 'Subscribed!' : 'Subscribe'}</span>
              </button>
            </form>
          </div>
        </div>
      </div>

      {/* Dot pattern overlay */}
      <div className="absolute inset-0 top-auto dot-pattern opacity-[0.02]" style={{ height: 'calc(100% - 120px)' }} />

      {/* Main Footer */}
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div>
            <div className="mb-6">
              <span className="text-2xl font-serif font-bold text-white">
                <span className="text-gradient-gold">Avdhoot</span> Group
              </span>
              <p className="text-[10px] font-sans uppercase tracking-widest-plus text-cream-200/30 mt-1">
                Est. 2023 &middot; Burhanpur
              </p>
            </div>
            <p className="text-cream-200/50 font-sans text-sm leading-relaxed mb-6">
              Building dreams into reality since 2023. Burhanpur's most trusted name in premium real estate development.
            </p>
            {/* Social Icons */}
            <div className="flex space-x-3">
              {/* Facebook */}
              <a href="#facebook" aria-label="Facebook" className="w-10 h-10 border border-gold/20 hover:border-gold hover:bg-gold/10 flex items-center justify-center transition-all duration-300">
                <svg className="w-4 h-4 text-cream-200/50 hover:text-gold" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                </svg>
              </a>
              {/* Instagram */}
              <a href="#instagram" aria-label="Instagram" className="w-10 h-10 border border-gold/20 hover:border-gold hover:bg-gold/10 flex items-center justify-center transition-all duration-300">
                <svg className="w-4 h-4 text-cream-200/50 hover:text-gold" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
                </svg>
              </a>
              {/* X (Twitter) */}
              <a href="#twitter" aria-label="X" className="w-10 h-10 border border-gold/20 hover:border-gold hover:bg-gold/10 flex items-center justify-center transition-all duration-300">
                <svg className="w-4 h-4 text-cream-200/50 hover:text-gold" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                </svg>
              </a>
              {/* LinkedIn */}
              <a href="#linkedin" aria-label="LinkedIn" className="w-10 h-10 border border-gold/20 hover:border-gold hover:bg-gold/10 flex items-center justify-center transition-all duration-300">
                <svg className="w-4 h-4 text-cream-200/50 hover:text-gold" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                </svg>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-serif text-lg mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {[
                { to: '/', label: 'Home' },
                { to: '/projects', label: 'Our Projects' },
                { to: '/about', label: 'About Us' },
                { to: '/contact', label: 'Contact' },
              ].map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="link-underline text-cream-200/50 hover:text-gold font-sans text-sm transition-colors duration-300"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Projects */}
          <div>
            <h4 className="text-white font-serif text-lg mb-6">Our Projects</h4>
            <ul className="space-y-3">
              {['Rameshwar Dham', 'Kesar Bagh', 'Dev Vatika'].map((project) => (
                <li key={project}>
                  <span className="text-cream-200/50 font-sans text-sm">{project}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-serif text-lg mb-6">Contact Us</h4>
            <ul className="space-y-4 text-sm font-sans text-cream-200/50">
              <li className="flex items-start space-x-3">
                <svg className="w-5 h-5 text-gold mt-0.5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                <span>Basant Mohan Complex,<br />Opposite Rana Marble,<br />Lalbagh Station Road, Burhanpur</span>
              </li>
              <li className="flex items-center space-x-3">
                <svg className="w-5 h-5 text-gold shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                <span>+91 94793 03333<br />+91 94794 33033</span>
              </li>
              <li className="flex items-center space-x-3">
                <svg className="w-5 h-5 text-gold shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                <span>info@avdhootgroup.in</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gold/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between">
          <p className="text-cream-200/30 font-sans text-sm">
            &copy; {new Date().getFullYear()} Avdhoot Group. All rights reserved.
          </p>
          <p className="text-cream-200/30 font-sans text-sm mt-2 sm:mt-0">
            Crafted with excellence in Burhanpur, MP
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
